import user from './user'
import card from './card'
import account from './account'
import templates from './templates'
import categories from './categories'
import authentication from './authentication'

export default {
  user,
  card,
  account,
  templates,
  categories,
  authentication,
}
